import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function LegalFooter() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const closeModal = () => setOpenModal(null);
  return <>
      <footer className="bg-[#0B1120] border-t border-slate-800/50 py-8 mt-auto" data-id="element-9">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center space-y-4" data-id="element-10">
          <p className="text-slate-500 text-sm text-center" data-id="element-11">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
          <div className="flex items-center gap-6 text-sm text-slate-400" data-id="element-12">
            <button onClick={() => setOpenModal('privacy')} className="hover:text-amber-500 transition-colors focus:outline-none" data-id="element-13">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-14">|</span>
            <button onClick={() => setOpenModal('terms')} className="hover:text-amber-500 transition-colors focus:outline-none" data-id="element-15">
              Términos de Servicio
            </button>
          </div>
          <p className="text-slate-600 text-xs mt-4" data-id="element-16">
            © {new Date().getFullYear()} Protocolo Adiós Cortisol. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {openModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" data-id="element-17">
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm transition-opacity" onClick={closeModal} data-id="element-18"></div>

          <div className="relative bg-[#0F172A] border border-slate-700 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden animate-in fade-in zoom-in-95 duration-200" data-id="element-19">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-slate-800" data-id="element-20">
              <h3 className="text-xl font-bold text-white" data-id="element-21">
                {openModal === 'privacy' ? 'Política de Privacidad' : 'Términos de Servicio'}
              </h3>
              <button onClick={closeModal} className="text-slate-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-slate-800" data-id="element-22">
                <X className="w-6 h-6" data-id="element-23" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6 overflow-y-auto text-slate-300 space-y-4 text-sm leading-relaxed" data-id="element-24">
              {openModal === 'privacy' ? <>
                  <p data-id="element-25">
                    <strong data-id="element-26">Última actualización:</strong>{' '}
                    {new Date().toLocaleDateString('es-ES')}
                  </p>
                  <p data-id="element-27">
                    En Protocolo Adiós Cortisol, valoramos y respetamos su
                    privacidad. Esta política explica cómo recopilamos, usamos y
                    protegemos su información personal cuando visita nuestro
                    sitio web y adquiere nuestros productos digitales.
                  </p>

                  <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-28">
                    1. Información que recopilamos
                  </h4>
                  <p data-id="element-29">
                    Recopilamos información que usted nos proporciona
                    directamente al realizar una compra, como su nombre,
                    dirección de correo electrónico y datos de pago (procesados
                    de forma segura a través de Hotmart).
                  </p>

                  <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-30">
                    2. Uso de la información
                  </h4>
                  <p data-id="element-31">
                    Utilizamos su información para procesar sus transacciones,
                    enviarle el producto digital adquirido, proporcionarle
                    soporte al cliente y enviarle comunicaciones relacionadas
                    con su compra.
                  </p>

                  <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-32">
                    3. Protección de datos
                  </h4>
                  <p data-id="element-33">
                    Implementamos medidas de seguridad estándar de la industria
                    para proteger su información personal. No vendemos,
                    intercambiamos ni transferimos a terceros su información
                    personal identificable.
                  </p>

                  <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-34">
                    4. Cookies
                  </h4>
                  <p data-id="element-35">
                    Utilizamos cookies para mejorar su experiencia en nuestro
                    sitio, analizar el tráfico y personalizar el contenido.
                    Puede configurar su navegador para rechazar las cookies,
                    aunque esto podría afectar la funcionalidad del sitio.
                  </p>
                </> : <>
                  <p data-id="element-36">
                    <strong data-id="element-37">Última actualización:</strong>{' '}
                    {new Date().toLocaleDateString('es-ES')}
                  </p>
                  <p data-id="element-38">
                    Al acceder y utilizar el sitio web de Protocolo Adiós
                    Cortisol y adquirir nuestros productos, usted acepta estar
                    sujeto a los siguientes Términos de Servicio.
                  </p>

                  <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-39">
                    1. Naturaleza del Producto
                  </h4>
                  <p data-id="element-40">
                    Protocolo Adiós Cortisol es un producto digital de carácter
                    informativo y educativo. No constituye consejo médico
                    profesional, diagnóstico ni tratamiento. Siempre consulte a
                    un médico o profesional de la salud calificado antes de
                    comenzar cualquier programa de salud o dieta.
                  </p>

                  <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-41">
                    2. Propiedad Intelectual
                  </h4>
                  <p data-id="element-42">
                    Todo el contenido incluido en este producto (textos, videos,
                    gráficos, guías) es propiedad exclusiva de Protocolo Adiós
                    Cortisol. Queda estrictamente prohibida su reproducción,
                    distribución, reventa o uso comercial sin autorización
                    expresa por escrito.
                  </p>

                  <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-43">
                    3. Política de Reembolso
                  </h4>
                  <p data-id="element-44">
                    Ofrecemos una garantía de satisfacción de 7 días. Si no está
                    satisfecho con el producto, puede solicitar un reembolso
                    completo dentro de los 7 días posteriores a la compra a
                    través de la plataforma de Hotmart.
                  </p>

                  <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-45">
                    4. Limitación de Responsabilidad
                  </h4>
                  <p data-id="element-46">
                    Los resultados pueden variar de persona a persona. No
                    garantizamos resultados específicos. El uso de la
                    información proporcionada es bajo su propio riesgo.
                  </p>
                </>}
            </div>

            {/* Modal Footer */}
            <div className="p-6 border-t border-slate-800 bg-[#0B1120] flex justify-end" data-id="element-47">
              <button onClick={closeModal} className="px-6 py-2 bg-slate-800 hover:bg-slate-700 text-white font-medium rounded-lg transition-colors" data-id="element-48">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}